import React, { useState } from 'react';
import InputError from '../InputError';
import './FormInput.scss';

export default function Input({ onChange, label, info, containerStyle, className, error, isnumeric, allowspaces, isphone, disabled, placeholder, showToggle, ...rest })
{
    const [visible, setVisible] = useState(false);

    const handleInput = (e)=>{
        if( isnumeric )
            e.target.value = e.target.value.replace(/[^0-9]/g, '');

        if( allowspaces === false )
            e.target.value = e.target.value.replace(/ /g, '');

        if( isphone )
            e.target.value = e.target.value.replace(/\+/g, '');

        return onChange(e);
    }

    const inputType = showToggle && rest.type === 'password'
        ? (visible ? 'text' : 'password')
        : rest.type;

    return (
        <div className={"form-input" + (rest.required ? ' required ' : '')}>
            { label ? <label>{label}</label> : null }
            <div className={showToggle ? 'form-input--with-toggle' : undefined}>
                <input
                    {...rest}
                    type={inputType}
                    disabled={disabled}
                    placeholder={placeholder}
                    title={placeholder || label || info || ''}
                    className={(error ? ' error ' : '') + (className || '')}
                    onChange={handleInput}
                />
                {showToggle && (
                    <button
                        type="button"
                        className="form-input--toggle"
                        onClick={() => setVisible(v => !v)}
                        tabIndex={-1}
                    >
                        <span className="material-symbols-outlined">
                            {visible ? 'visibility_off' : 'visibility'}
                        </span>
                    </button>
                )}
            </div>
            { error ? <InputError error={error}/> : null }
        </div>
    )
}